import { addressToScriptHash, common, utils, } from '@neo-one/client-common';
import * as args from '../args';
import { InvalidArgumentError } from '../errors';
export const params = {
    String: (name, param, parameter) => parameter.optional && param === undefined ? undefined : args.assertString(name, param),
    Address: (name, param, parameter) => parameter.optional && param === undefined
        ? undefined
        : common.stringToUInt160(addressToScriptHash(args.assertAddress(name, param))),
    Hash256: (name, param, parameter) => parameter.optional && param === undefined ? undefined : common.stringToUInt256(args.assertHash256(name, param)),
    PublicKey: (name, param, parameter) => parameter.optional && param === undefined ? undefined : common.stringToECPoint(args.assertPublicKey(name, param)),
    Integer: (name, param, parameter) => {
        if (parameter.optional && param === undefined) {
            return undefined;
        }
        const value = args.assertBigNumber(name, param);
        return utils.bigNumberToBN(value, parameter.decimals);
    },
    Boolean: (name, param, parameter) => parameter.optional && param === undefined ? undefined : args.assertBoolean(name, param),
    Buffer: (name, param, parameter) => parameter.optional && param === undefined ? undefined : Buffer.from(args.assertBuffer(name, param), 'hex'),
    Signature: (name, param, parameter) => parameter.optional && param === undefined ? undefined : Buffer.from(args.assertBuffer(name, param), 'hex'),
    Array: (name, param, parameter) => {
        if (parameter.optional && param === undefined) {
            return undefined;
        }
        const paramArray = args.assertArray(name, param);
        const { value } = parameter;
        const checker = params[value.type];
        return paramArray.map((val) => checker(name, val, value));
    },
    Map: (name, param, parameter) => {
        if (parameter.optional && param === undefined) {
            return undefined;
        }
        const paramMap = args.assertMap(name, param);
        const { key, value } = parameter;
        const keyChecker = params[key.type];
        const valueChecker = params[value.type];
        const output = new Map();
        paramMap.forEach((v, k) => {
            output.set(keyChecker(name, k, key), valueChecker(name, v, value));
        });
        return output;
    },
    Object: (name, param, parameter) => {
        if (parameter.optional && param === undefined) {
            return undefined;
        }
        const paramObject = args.assertObject(name, param);
        return Object.entries(paramObject).reduce((acc, [keyParam, val]) => {
            const key = args.assertString(name, keyParam);
            const value = parameter.properties[key];
            if (value === undefined) {
                throw new Error('Invalid abi');
            }
            const checker = params[value.type];
            return {
                ...acc,
                [key]: checker(name, val, value),
            };
        }, {});
    },
    Void: (name, param, _parameter) => {
        if (param !== undefined) {
            throw new InvalidArgumentError('Void', name, param);
        }
        return param;
    },
    ForwardValue: (name, param, parameter) => parameter.optional && param === undefined ? undefined : args.assertForwardValue(name, param).converted,
};

//# sourceMappingURL=params.js.map
